import type {RouteRecordRaw} from 'vue-router';
import type {CommonRouteMeta} from '@/types/common';
import {SCHEDULED_EMAILS_HELP_URL} from '@/utils/scheduledEmailConstants';

// Lazy-loaded components
const BaseDashboard = () => import('@/views/dashboard/BaseDashboard.vue');
const BaseOrders = () => import('@/views/dashboard/orders/BaseOrders.vue');
const OrderNewV2 = () => import('@/views/dashboard/orders/OrderNewV2.vue');
const OrderSingleV2 = () => import('@/views/dashboard/orders/OrderSingleV2.vue');
const TheRightSidebar = () => import('@/components/dashboard/TheRightSidebar.vue');
const AddNewOrder = () => import('@/components/dashboard/navActions/AddNewOrder.vue');
const NewOrderOptions = () => import('@/components/dashboard/navActions/NewOrderOptions.vue');
const SingleOrderOptions = () => import('@/components/dashboard/navActions/SingleOrderOptions.vue');


const ordersRoutes: RouteRecordRaw[] = [
    {
        path: '/orders',
        components: {
            default: BaseDashboard,
        },
        meta: {
            title: 'orders',
            icon: 'mdi-newspaper-variant-multiple-outline',
            noCache: false,
            isBase: true,
            permissions: ['orders_view'],
            showInMenu: true,
            middleware: ['auth'],
            layout: 'Dashboard',
        } as CommonRouteMeta,
        children: [
            {
                path: '',
                components: {
                    default: BaseOrders,
                    navRightActions: AddNewOrder,
                },
                name: 'orders.index',
                meta: {
                    title: 'Orders',
                    icon: 'mdi-account-outline',
                    noCache: false,
                    isBase: true,
                    helpArticle: 'https://help.fleetwire.io/en/article/the-fleetwire-order-workflow-12z4rr4/',
                },
            },
            {
                path: 'upcoming',
                components: {
                    default: BaseOrders,
                    navRightActions: AddNewOrder,
                },
                name: 'orders.index.upcoming',
                meta: {title: 'Orders Upcoming', icon: 'mdi-account-outline', noCache: false, isBase: true},
            },
            {
                path: 'scheduled-emails',
                components: {
                    default: () => import('@/views/dashboard/orders/ScheduledEmailsIndex.vue'),
                    navRightActions: AddNewOrder,
                },
                name: 'orders.scheduled-emails',
                meta: {
                    title: 'Scheduled Emails',
                    icon: 'mdi-email-clock-outline',
                    noCache: false,
                    isBase: true,
                    helpArticle: SCHEDULED_EMAILS_HELP_URL,
                },
            },
            {
                path: 'overdue',
                components: {
                    default: BaseOrders,
                    navRightActions: AddNewOrder,
                },
                name: 'orders.index.overdue',
                meta: {title: 'Orders Overdue', icon: 'mdi-account-outline', noCache: false, isBase: true},
            },
            {
                path: 'new',
                components: {
                    default: OrderNewV2,
                    navRightActions: NewOrderOptions,
                },
                name: 'orders.new',
                meta: {
                    title: 'New',
                    icon: 'mdi-account-outline',
                    noCache: false,
                    hasRightSidebar: false,
                    helpArticle: 'https://help.fleetwire.io/en/article/manually-creating-orders-in-fleetwire-1a0bxvw/',
                },
            },
            {
                path: 'new-order',
                components: {
                    default: OrderNewV2,
                    rightSidebar: TheRightSidebar,
                    navRightActions: NewOrderOptions,
                },
                name: 'orders.newV2',
                meta: {title: 'New', icon: 'mdi-account-outline', noCache: false, hasRightSidebar: true},
            },
            {
                path: ':b_id',
                components: {
                    default: OrderSingleV2,
                    rightSidebar: TheRightSidebar,
                    navRightActions: SingleOrderOptions,
                },
                name: 'orders.single',
                meta: {
                    title: 'order',
                    icon: 'mdi-account-outline',
                    noCache: false,
                    hasRightSidebar: true,
                    resource: 'b_id',
                    isBase: false
                },
            },
            {
                path: 'v2/:b_id',
                components: {
                    default: OrderSingleV2,
                    rightSidebar: TheRightSidebar,
                    navRightActions: SingleOrderOptions,
                },
                name: 'orders.singleV2',
                meta: {title: 'order', icon: 'mdi-account-outline', noCache: false, hasRightSidebar: true, resource: 'b_id'},
            },
        ],
    }
];

export default ordersRoutes;
